import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

import Nav             from "./Landing/Nav";
import Footer          from "./Landing/Footer";
import CinematicHero   from "./Landing/sections/CinematicHero";
import LiveProofSection from "./Landing/sections/LiveProof";
import TruthSection    from "./Landing/sections/Truth";
import FeaturesSection from "./Landing/sections/Features";
import CorridorsSection from "./Landing/sections/Corridors";
import TestimonialsSection from "./Landing/sections/Testimonials";
import BusinessSection from "./Landing/sections/Business";
import FaqSection      from "./Landing/sections/FAQ";
import EmotionalEnding from "./Landing/sections/EmotionalEnding";

export default function Landing() {
  const { user }     = useAuth();
  const navigate     = useNavigate();
  const [scrolled,   setScrolled ] = useState(false);
  const [mobileNav,  setMobileNav] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 56);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  const goToApp = useCallback(
    () => navigate(user ? (user.role === "admin" ? "/admin" : "/app/dashboard") : "/register"),
    [user, navigate],
  );

  return (
    <div className="min-h-screen overflow-x-hidden bg-void">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[200] focus:px-4 focus:py-2 focus:rounded-lg focus:bg-emerald focus:text-white focus:text-sm focus:font-bold"
      >
        Skip to content
      </a>
      <Nav
        scrolled={scrolled}
        user={user}
        mobileNav={mobileNav}
        setMobileNav={setMobileNav}
        goToApp={goToApp}
      />
      <main id="main-content">
        <CinematicHero goToApp={goToApp} user={user} />
        <LiveProofSection />
        <TruthSection />
        <FeaturesSection />
        <CorridorsSection goToApp={goToApp} />
        <TestimonialsSection />
        <BusinessSection goToApp={goToApp} />
        <FaqSection />
        <EmotionalEnding goToApp={goToApp} />
      </main>
      <Footer />
    </div>
  );
}
